import { render, staticRenderFns } from "./OrganisationAmountTotal.vue?vue&type=template&id=f2addec8&"
import script from "./OrganisationAmountTotal.vue?vue&type=script&lang=js&"
export * from "./OrganisationAmountTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports